/**
 * Utility to safely strip HTML tags and unescape raw HTML strings / code snippets for message previews across all dashboard widgets & inbox screens.
 */
export const stripHtml = (html) => {
    if (!html) return '';
    try {
        const formatted = String(html)
            .replace(/<br\s*\/?>/gi, ' ')
            .replace(/<\/p>/gi, ' ')
            .replace(/<\/div>/gi, ' ')
            .replace(/<\/tr>/gi, ' ');
        const doc = new DOMParser().parseFromString(formatted, 'text/html');
        let text = doc.body.textContent || doc.body.innerText || '';
        // Handle double-encoded HTML strings (e.g., &lt;div style=...)
        if (text.includes('<') && text.includes('>')) {
            const doc2 = new DOMParser().parseFromString(text, 'text/html');
            text = doc2.body.textContent || doc2.body.innerText || text;
        }
        return text.replace(/\s+/g, ' ').trim();
    } catch {
        return String(html).replace(/<[^>]*>?/gm, ' ').replace(/\s+/g, ' ').trim();
    }
};
